import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Approved from './Approved';
import LoginDNIPage from './LoginDNIPage';
import Step1 from './Step1';
import ViewPDFBridge from './ViewPDFBridge';
import EmailPDF from './EmailPDF';
import EmailPDFSent from './EmailPDFSent';
import Init from './Init';

const App = () => {
	useEffect(() => {
		console.log(process.env.NODE_ENV);
		localStorage.setItem("push", "0");
	}, []);

	return (
		<Router>
			<Routes>
				<Route path="/" element={<Init />} />
				<Route path="/:lead_id" element={<Init />} />
				<Route path="/onboarding" element={<Step1 />} />
				<Route path="/onboarding/nif" element={<LoginDNIPage />} />
				<Route path="/onboarding/approved" element={<Approved />} />
				<Route path="/onboarding/view-pdf/:lead_id" element={<ViewPDFBridge />} />
				<Route path="/onboarding/email" element={<EmailPDF />} />
				<Route path="/onboarding/email/sent" element={<EmailPDFSent />} />
			</Routes>
		</Router>
	);
};

export default App;